/**
 * Created by andrey on 09.02.2021.
 */

// eslint-disable-next-line no-unused-vars
const EditorMap2dDecoratorView = Map2dDecoratorView.extend({
    ctor: function (decorator) {
        this._super(decorator);

        this.baseScaleX = decorator.scaleX || 1;
        this.baseScaleY = decorator.scaleY || 1;

        if (!decorator.isDynamic()) {
            this.addHover();

            cleverapps.UI.onClick(this, () => {
                if (this.isOrangeryEraser() || cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.Delete)) {
                    this.onDeletePressed(true);
                    return;
                }

                if (cleverapps.sceneDebugger.selectedNode === this) {
                    cleverapps.sceneDebugger.unselectNode(this);
                } else {
                    cleverapps.sceneDebugger.selectNode(this);
                }
            }, {
                filter: EditorMap2dDecoratorView.FILTER
            });

            this.onDeletePressed = cleverapps.accumulate(0, this.onDeletePressed.bind(this));
        }

        decorator.updateLargeBox = this.createListener(this.updateLargeBox.bind(this));
        decorator.updateParent = this.createListener(this.updateParent.bind(this));
        decorator.updateDecorator = this.createListener(this.updateDecorator.bind(this));
    },

    updateParent: function () {
        Map2d.currentMap.getMapView().addTile(this.decorator.getLayerId(), this.decorator.x, this.decorator.y, this);

        if (this.selected) {
            this.onSceneUnselected();
            this.onSceneSelected();
        }
    },

    addHover: function () {
        if (this.hoverHandler) {
            return;
        }

        this.hoverHandler = cleverapps.UI.applyHover(this, {
            filter: EditorMap2dDecoratorView.FILTER,
            onMouseOver: this.onMouseOver.bind(this)
        });
    },

    onMouseOver: function () {
        if (this.isOrangeryEraser() && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.b)) {
            this.onDeletePressed(true);
        }
    },

    isOrangeryEraser: function () {
        const orangery = Editor.currentEditor.orangery;
        return orangery && orangery.selected && orangery.selected.eraser && orangery.selected.id === MergeOrangery.DECORATOR_ID;
    },

    debugSetParentCell: function (deltaX, deltaY) {
        if (!deltaX && !deltaY) {
            return;
        }

        deltaY = -deltaY;

        const target = cc.p(this.decorator.x + deltaX, this.decorator.y + deltaY);

        if (!Map2d.currentMap.isValid(target.x, target.y)) {
            return;
        }

        const mapView = Map2d.currentMap.getMapView();
        const cell = mapView.getCell(target.x, target.y);

        const dx = Math.round((this.x - cell.x) / resolutionScale);
        const dy = Math.round((this.y - cell.y) / resolutionScale);

        Editor.currentEditor.doCommand("changeDecoratorCell", {
            oldX: this.decorator.x,
            oldY: this.decorator.y,
            hash: this.decorator.getDecoratorHash(),
            x: target.x,
            y: target.y,
            dx,
            dy
        });
    },

    debugSetLocalZOrder: function (zOrderDelta) {
        const intersecting = Map2d.currentMap.decorators.findIntersectingDecorators(this.decorator);
        if (intersecting.length < 2) {
            return;
        }

        intersecting.sort(cc.isoRectComparator);

        const index = intersecting.indexOf(this.decorator);
        if (index === -1) {
            return;
        }

        const target = zOrderDelta > 0 ? intersecting[index + 1] : intersecting[index - 1];
        if (!target) {
            return;
        }

        const list = Map2d.currentMap.decorators.getDecorators(target.x, target.y);
        const targetIndex = list ? list.indexOf(target) : -1;
        const insertIndex = zOrderDelta > 0 ? targetIndex + 1 : targetIndex;

        const mapView = Map2d.currentMap.getMapView();
        const cell = mapView.getCell(target.x, target.y);

        const dx = Math.round((this.x - cell.x) / resolutionScale);
        const dy = Math.round((this.y - cell.y) / resolutionScale);

        Editor.currentEditor.doCommand("changeDecoratorCell", {
            oldX: this.decorator.x,
            oldY: this.decorator.y,
            hash: this.decorator.getDecoratorHash(),
            x: target.x,
            y: target.y,
            index: insertIndex,
            dx,
            dy
        });
    },

    debugSetScale: function (scaleX, scaleY) {
        const valueToFixed = function (value) {
            return +(value).toFixed(2);
        };

        this.baseScaleX = valueToFixed(scaleX);
        this.baseScaleY = valueToFixed(scaleY);

        Editor.currentEditor.doCommand("scaleDecorator", {
            x: this.decorator.x,
            y: this.decorator.y,
            hash: this.decorator.getDecoratorHash(),
            scaleX: this.baseScaleX,
            scaleY: this.baseScaleY
        });
    },

    debugSetRotation: function (rotation) {
        Editor.currentEditor.doCommand("rotateDecorator", {
            x: this.decorator.x,
            y: this.decorator.y,
            hash: this.decorator.getDecoratorHash(),
            rotation
        });
    },

    debugSetPosition: function (x, y) {
        const mapView = Map2d.currentMap.getMapView();
        const gridCell = mapView.getCellByCoordinates(cc.p(x, y));
        const newX = Math.round(gridCell.x);
        const newY = Math.round(gridCell.y);

        const canChangeCell = Map2d.currentMap.isValid(newX, newY)
            && (newX !== this.decorator.x || newY !== this.decorator.y)
            && !this.wouldChangeDrawOrder(newX, newY);

        if (canChangeCell) {
            const cell = mapView.getCell(newX, newY);
            const dx = Math.round((x - cell.x) / resolutionScale);
            const dy = Math.round((y - cell.y) / resolutionScale);

            Editor.currentEditor.doCommand("changeDecoratorCell", {
                oldX: this.decorator.x,
                oldY: this.decorator.y,
                hash: this.decorator.getDecoratorHash(),
                x: newX,
                y: newY,
                dx,
                dy
            });
        } else {
            const cell = mapView.getCell(this.decorator.x, this.decorator.y);
            const dx = Math.round((x - cell.x) / resolutionScale);
            const dy = Math.round((y - cell.y) / resolutionScale);

            Editor.currentEditor.doCommand("moveDecorator", {
                x: this.decorator.x,
                y: this.decorator.y,
                hash: this.decorator.getDecoratorHash(),
                dx,
                dy
            });
        }
    },

    wouldChangeDrawOrder: function (newX, newY) {
        const intersecting = Map2d.currentMap.decorators.findIntersectingDecorators(this.decorator);

        const cells = intersecting.map((decorator) => ({
            current: cc.p(decorator.x, decorator.y),
            new: decorator === this.decorator ? cc.p(newX, newY) : cc.p(decorator.x, decorator.y),
            changed: decorator === this.decorator
        }));

        cells.sort((a, b) => cc.isoRectComparator(a.current, b.current));

        for (let i = 1; i < cells.length; i++) {
            const cellA = cells[i - 1];
            const cellB = cells[i];

            if ((cc.isoRectComparator(cellA.new, cellB.new) || cellA.changed - cellB.changed) > 0) {
                return true;
            }
        }

        return false;
    },

    onDeletePressed: function (silent) {
        // eslint-disable-next-line no-restricted-globals
        const isConfirmed = silent || confirm(`Delete decorator "${this.decorator.code}'?`);
        if (!isConfirmed) {
            return;
        }

        Editor.currentEditor.doCommand("removeDecorator", {
            x: this.decorator.x, y: this.decorator.y, hash: this.decorator.getDecoratorHash()
        });
    },

    onSceneSelected: function () {
        this.selected = true;

        if (this.hoverHandler) {
            this.hoverHandler.remove();
            this.hoverHandler = undefined;
        }

        if (this.point) {
            this.point.removeFromParent();
            this.point = undefined;
        }

        const image = new cc.Sprite(bundles.editor.frames.cell_center_png);
        image.setColor(cc.color(255, 0, 0, 255));

        const text = cleverapps.UI.generateOnlyText("Cell", cleverapps.styles.FONTS.SYSTEM);

        this.point = new cleverapps.Layout([text, image], {
            direction: cleverapps.UI.VERTICAL
        });
        this.point.setAnchorPoint(0.5, 0.5);
        this.point.setLocalZOrder(100);

        const mapView = Map2d.currentMap.getMapView();
        mapView.alignViewInGrid(this.decorator.x, this.decorator.y, this.point);
        mapView.animations.addChild(this.point);

        EditorMap2dDecoratorView.ToggleHint(true);

        this.skipCapture = true;
    },

    onSceneUnselected: function (silent) {
        this.selected = false;

        if (this.point) {
            this.point.removeFromParent();
            this.point = undefined;
        }

        this.addHover();

        cleverapps.toolModel.hide(true);
        cleverapps.toolModel.backToRoot();
        EditorMap2dDecoratorView.ToggleHint(false, silent);

        if (this.skipCapture) {
            delete this.skipCapture;
        }
    },

    updateLargeBox: function () {
        const map2dView = Map2d.currentMap.getMapView();
        const position = map2dView.alignInGrid(this.decorator.x, this.decorator.y);

        const cellRect = cc.rect(
            -cleverapps.styles.Map2dView.cell.width / 2,
            -cleverapps.styles.Map2dView.cell.height / 2,
            cleverapps.styles.Map2dView.cell.width,
            cleverapps.styles.Map2dView.cell.height
        );

        const boundingBox = this.getBoundingBox();
        boundingBox.x -= position.x;
        boundingBox.y -= position.y;

        let largeBox = cc.rectUnion(cellRect, boundingBox);

        const isLarge = largeBox.width > cleverapps.styles.Map2dView.cell.width * 2
            || largeBox.height > cleverapps.styles.Map2dView.cell.height * 2;

        largeBox = cc.rect(
            Math.floor(largeBox.x / resolutionScale),
            Math.floor(largeBox.y / resolutionScale),
            Math.ceil(largeBox.width / resolutionScale + 1),
            Math.ceil(largeBox.height / resolutionScale + 1)
        );

        this.decorator.setLargeBox(isLarge ? largeBox : undefined);
    },

    debugGetName: function () {
        return this.decorator.code;
    }
});

EditorMap2dDecoratorView.ToggleHint = function (active, silent) {
    if (active) {
        const keyToLetter = {};
        for (const keyName in InputDispatcher.KEY) {
            keyToLetter[InputDispatcher.KEY[keyName]] = keyName;
        }

        const commands = [];
        Object.keys(cleverapps.NodeDebugCommands).forEach((name) => {
            const command = cleverapps.NodeDebugCommands[name];
            if ((!command.filter || command.filter.call(cleverapps.sceneDebugger.selectedNode))) {
                commands.push({
                    key: `${command.key !== undefined ? `${keyToLetter[command.key]} + ` : ""}⬅⬆`,
                    description: command.description.trim()
                });
            }
        });

        if (!EditorMap2dDecoratorView.activeHint) {
            EditorMap2dDecoratorView.activeHint = new EditorHintView();
            addCleaner(EditorMap2dDecoratorView.activeHint, () => {
                delete EditorMap2dDecoratorView.activeHint;
            });
            cleverapps.Scenes.GetRunningScene().addChild(EditorMap2dDecoratorView.activeHint);
        }

        EditorMap2dDecoratorView.activeHint.refresh(commands);
    } else if (EditorMap2dDecoratorView.activeHint) {
        EditorMap2dDecoratorView.activeHint.hide(silent);
    }
};

EditorMap2dDecoratorView.FILTER = function () {
    const editor = Editor.currentEditor;
    const isOrangeryEraser = editor.selected && editor.selected.eraser && editor.selected.id === MergeOrangery.DECORATOR_ID;
    return editor.layer === Map2dEditor.LAYER_DECORATORS && (!editor.selected || isOrangeryEraser);
};
